import React from 'react'
import "./BlackberryService.scss"

const serviceData = [
    {
        id: 1,
        title: "Alterations",
        description: "Get free personalised alterations on Dresses,Gowns,Legengas,Cord sets in store",
        buttonText: "Free Alterations",
        image: "/assets/img/elnora/rpthree.webp"
    },
    {
        id: 2,
        title: "On Call Consultation",
        description: "Get on demand call with our expert stylist, who will help you in curating looks for any occasion.",
        buttonText: "Book Now",
        image: "/assets/img/elnora/rpeight.jpeg"
    },
    {
        id: 3,
        title: "Walk in",
        description: "Walk in at elnora store. We are present in Delhi",
        buttonText: "Find Location",
        image: "/assets/img/elnora/elnoralogo.png"
    }
]

const BlackberryService = () => {
    return (
        <div className="bb-service">
            <div className="bb-service__container">
                <div className="bb-service__header">
                    <h4>YOU ARE SPECIAL</h4>
                    <h2 className="bb-service__title">OUR SERVICES</h2>
                </div>
                <div className="bb-service__grid">
                    {serviceData.map((service) => (
                        <div key={service.id} className="bb-service__card">
                            <div className="bb-service__image-wrapper">
                                <img 
                                    src={service.image} 
                                    alt={service.title}
                                    className="bb-service__image"
                                />
                            </div>
                            <div className="bb-service__content">
                                <h3 className="bb-service__card-title">{service.title}</h3>
                                <p className="bb-service__description">{service.description}</p>
                                <button className="bb-service__button">
                                    {service.buttonText}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BlackberryService;